(function () {
    'use strict';

    a3_pilot_reports.factory('CatIIFactory', CatIIFactory);
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name CatIIFactory
    * @description 
    * Get and Update Crew Meals 
    * @ngInject
    */
    function CatIIFactory(GenericService,showCatIIApprachAcTypes) {

        /**
         * Initialize the CatII
         * @memberof CatIIFactory
         */
        function CatII() {
            this.catIICount = null;
            this.flightsLeft = 0;
            this.totalOAFlights = 0;
            this.showCatIIModal = false;
        }

        var objType = 'catII';
        var objCallback = CatII;

        var service = {
            getCatIIFromStorage: getCatIIFromStorage,
            setCatIIToStorage: setCatIIToStorage,
            showCatIIModal: showCatIIModal,
            canShowCatIIModal: canShowCatIIModal
        };

        /**
         * Get CatII object from storage
         * @memberof CatIIFactory
         */
        function getCatIIFromStorage() {
            return GenericService.getOne(objType, objCallback);
        }

        /**
         * Save catIIRelated Data to storage
         * @memberof CatIIFactory
         * @param {number} CatIIOperations the number of catII operations of current month
         * @param {object} flights the flight object of sync response
         */
        function setCatIIToStorage(CatIIOperations, flights) {
            var flightsLeft = 0;
            var totalOlympicFlights = 0;
            if (flights.length > 0) {
                var oaFlights = getOAFlightsForCurrentMonth(flights);
                flightsLeft = getFlightsLeftForCurrentMonth(oaFlights);
                totalOlympicFlights = oaFlights.length;
            }
            var catII = { catIICount: CatIIOperations, totalOAFlights: totalOlympicFlights, flightsLeft: flightsLeft, showCatIIModal: true }
            GenericService.saveOne(catII, objType, objCallback);
        }
        /**
         * Update catII object to storage
         * @memberof CatIIFactory
         * @param {bool} canShowModal whether the modal can be display
         */
        function showCatIIModal(canShowModal){
            var catII = GenericService.getOne(objType, objCallback);
            catII.showCatIIModal = canShowModal;
            GenericService.saveOne(catII, objType, objCallback);
            
        }
        /**
         * Gets the value of showCatIIModal property
         * @memberof CatIIFactory
         * @returns {bool} returns the value of showCatIIModal property
         */
        function canShowCatIIModal(){
            var catII = GenericService.getOne(objType, objCallback);
            return catII && catII.showCatIIModal; 
        }

        /**
         * Get the count of fligths after the current time
         * @memberof CatIIFactory
         * @param {object} flights the flight object of sync response
         * @returns {number} returns the count of fligths after the current time
         */
        function getFlightsLeftForCurrentMonth(flights) {
            var flightDates = flights.map(a => a.ScheduledArrival);
            var date = new Date();
            //uncomment for testig purposes
            //var date = new Date(2016, 1, 8);
            var filteredDays = flightDates.filter(x => moment.utc(x) >= moment.utc(date))
            return filteredDays.length;
        }

        /**
         * Get Olympic air Flights For Current Month
         * @memberof CatIIFactory
         * @param {object} flights the flight object of sync response
         * @returns {Array} returns array of fligths that the user is not DHC the flight is for olympic and the userposition is CP
         */
        function getOAFlightsForCurrentMonth(flights) {
            var date = new Date();
            var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            
            // //Uncomment for testing purposes
            //  var firstDayOfMonth = new Date(2016, 1, 1);
            //  var lastDayOfMonth = new Date(2016, 1, 30);

            return flights.filter(x => x.Position == "CP"
                && x.IsDHC == false
                && showCatIIApprachAcTypes.includes(x.AcType)
                    && moment.utc(x.DutyDate) >= moment.utc(firstDayOfMonth)
                    && moment.utc(x.DutyDate) <= moment.utc(lastDayOfMonth));
        }
        return service;
    }

})();